import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from './api';
import styled from 'styled-components';
import dayjs from 'dayjs';

const Container = styled.div`
  max-width: 1000px;
  margin: 10px auto;
  padding: 15px;
  font-family: 'Inter', sans-serif;
`;

const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: 80px repeat(${props => props.cols || 1}, 1fr);
  border: 1px solid #e2e8f0;
  background: white;
  margin-top: 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

const HeaderCell = styled.div`
  padding: 12px 5px;
  text-align: center;
  font-weight: 700;
  background: #f8fafc;
  color: #475569;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 0.025em;
  border-bottom: 2px solid #e2e8f0;
  border-right: 1px solid #f1f5f9;
`;

const TimeCell = styled.div`
  padding: 10px 8px;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
  border-bottom: 1px solid #f1f5f9;
  border-right: 1px solid #f1f5f9;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SlotCell = styled.div`
  border-bottom: 1px solid #f1f5f9;
  border-right: 1px solid #f1f5f9;
  min-height: 45px;
  position: relative;
  transition: background-color 0.2s;
  background-color: ${props => props.active ? '#eff6ff' : 'transparent'};
  
  &:hover {
    background-color: ${props => props.active ? '#dbeafe' : '#f8fafc'};
  }
`;

const ScheduleTag = styled.div`
  background: #2563eb;
  color: white;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 4px 6px;
  border-radius: 6px;
  margin: 3px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

function CalendarioDocente() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [docente, setDocente] = useState(null);
  const [horarios, setHorarios] = useState([]);
  const [dias, setDias] = useState([]);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    try {
      const [resD, resH, resDias] = await Promise.all([
        api.get(`/docentes/${id}`).catch(() => ({ data: { nombres: 'Docente', apellido_paterno: '(ID: ' + id + ')' } })),
        api.get(`/horarios?id_docente=${id}`).catch(() => ({ data: [] })),
        api.get('/dias').catch(() => ({ data: [] }))
      ]);
      setDocente(resD.data);
      setHorarios(resH.data);
      setDias(resDias.data);
    } catch (err) { 
      console.error('Error cargando datos del calendario:', err);
      Swal.fire('Error', 'No se pudieron cargar todos los datos del calendario', 'error');
    }
  };

  if (!docente) return <div>Cargando...</div>;

  // Generar horas de 07:00 a 22:00
  const hours = Array.from({ length: 16 }, (_, i) => `${(i + 7).toString().padStart(2, '0')}:00`);

  return (
    <Container>
      <button onClick={() => navigate(-1)} style={{ marginBottom: '15px', padding: '8px 15px', borderRadius: '8px', border: 'none', background: '#eee', cursor: 'pointer' }}>← Volver</button>
      <h2>📅 Horario Semanal: {docente.nombres} {docente.apellido_paterno}</h2>
      
      <CalendarGrid cols={dias.length}>
        <HeaderCell>Hora</HeaderCell>
        {dias.map(d => (
          <HeaderCell key={d.dia_id}>{d.dia_detalle}</HeaderCell>
        ))}

        {hours.map(hour => (
          <React.Fragment key={hour}>
            <TimeCell>{hour}</TimeCell>
            {dias.map(d => {
              const currentH = parseInt(hour.substring(0, 2));
              const matches = horarios.filter(h => {
                if (!h.Periodo) return false;
                const hEntrada = parseInt(h.Periodo.per_hora_entrada.substring(0, 2));
                const hSalida = parseInt(h.Periodo.per_hora_salida.substring(0, 2));
                return h.dia_semana === d.dia_id && currentH >= hEntrada && currentH < hSalida;
              });
              return (
                <SlotCell key={d.dia_id} active={matches.length > 0}>
                  {matches.map((m, i) => (
                    <ScheduleTag key={i}>
                      {m.Periodo?.per_detalle}
                    </ScheduleTag>
                  ))}
                </SlotCell>
              );
            })}
          </React.Fragment>
        ))}
      </CalendarGrid>
    </Container>
  );
}

export default CalendarioDocente;
